export const notificationConsts = {
  SHOW_NOTIFICATION: '[Notification] SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: '[Notification] HIDE_NOTIFICATION',
};
